import axios from "axios";
import {server} from "@/variables";

export function sendNotification(clients, link, message, buttons, sendPriceList) {
    return new Promise((resolve, reject) => {
        const token = localStorage.getItem('token');
        axios.post(`${server}/notificate`, {clients, link, message, buttons, sendPriceList}, {headers: {'admin-token': token}})
            .then((data) => {
                return resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    })
}